(function(){
if(window.__lumlyLw)return;window.__lumlyLw=true;
var RM=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var A=[245,166,35];
function clamp(v,a,b){return Math.max(a,Math.min(b,v));}
function itNum(v,d){var s=(d?v.toFixed(d):Math.round(v).toString());var p=s.split('.');p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,'.');return p.join(',');}
function setHdr(){var h=document.getElementById('LumlyHeader');if(h)document.documentElement.style.setProperty('--lw-hdr',h.offsetHeight+'px');}
setHdr();
var mats=[];
function Matrix(el,mode){
this.el=el;this.mode=mode||'led';this.gain=1;this.vis=false;this.t0=Math.random()*20000;
this.c=document.createElement('canvas');this.c.className='lw-canvas';this.c.setAttribute('aria-hidden','true');
el.insertBefore(this.c,el.firstChild);this.x=this.c.getContext('2d');this.resize();mats.push(this);
}
Matrix.prototype.resize=function(){
var r=this.el.getBoundingClientRect(),d=Math.min(window.devicePixelRatio||1,2);
this.w=r.width;this.h=r.height;this.c.width=Math.max(1,Math.floor(r.width*d));this.c.height=Math.max(1,Math.floor(r.height*d));
this.x.setTransform(d,0,0,d,0,0);
this.s=this.mode==='glass'?15:clamp(r.width / 105,8,14);
};
Matrix.prototype.draw=function(t){
var x=this.x,w=this.w,h=this.h;if(!w||!h)return;t+=this.t0;x.clearRect(0,0,w,h);
if(this.mode==='wave')return this.sphere(t);
var s=this.s,g=this.gain,glass=this.mode==='glass';
var gx=w*(0.5+0.33*Math.sin(t*0.00021)),gy=h*(0.5+0.27*Math.cos(t*0.00029));
var sig=Math.min(w,h)*0.24,s2=2*sig*sig;
for(var yy=s / 2;yy<h;yy+=s){
for(var xx=s / 2;xx<w;xx+=s){
var wv=Math.sin(xx*0.011+t*0.0009)+Math.sin(yy*0.016-t*0.0012)+Math.sin((xx+yy)*0.005+t*0.0005);
var it=(wv+3)/ 6;it*=it;
var dx=xx-gx,dy=yy-gy,b=Math.exp(-(dx*dx+dy*dy)/ s2);
var a=((glass?0.04:0.06)+(glass?0.22:0.42)*it+0.95*b)*g;if(a<0.035)continue;
var m=Math.min(1,b*1.3);
x.fillStyle='rgba('+((A[0]+(255-A[0])*m)|0)+','+((A[1]+(238-A[1])*m)|0)+','+((A[2]+(215-A[2])*m)|0)+','+Math.min(1,a).toFixed(3)+')';
x.beginPath();x.arc(xx,yy,s*(0.15+0.15*it+0.15*b),0,6.2832);x.fill();
}
}
if(glass){x.fillStyle='rgba(255,255,255,0.06)';x.fillRect(Math.round(w*0.5),0,1,h);}
};
Matrix.prototype.sphere=function(t){
var x=this.x,w=this.w,h=this.h,R=Math.min(w,h)*0.36,cx=w / 2,cy=h / 2,rot=t*0.00028,N=24;
var gr=x.createRadialGradient(cx,cy,R*0.3,cx,cy,R*1.7);gr.addColorStop(0,'rgba(245,166,35,0.16)');gr.addColorStop(1,'rgba(245,166,35,0)');
x.fillStyle=gr;x.fillRect(0,0,w,h);
for(var i=1;i<N;i++){
var lat=-Math.PI / 2+Math.PI*i / N,cl=Math.cos(lat),sl=Math.sin(lat),M=Math.max(6,Math.round(2*N*cl));
for(var j=0;j<M;j++){
var lon=2*Math.PI*j / M+rot,X=cl*Math.sin(lon),Z=cl*Math.cos(lon);
if(Z<-0.02)continue;
var wv=(Math.sin(lon*3-t*0.0016)+Math.sin(lat*5+t*0.0011)+2)/ 4;
var a=(0.12+0.88*wv*wv)*(0.3+0.7*Z)*this.gain;
x.fillStyle='rgba(255,'+((166+72*wv)|0)+','+((35+160*wv*Z)|0)+','+Math.min(1,a).toFixed(3)+')';
x.beginPath();x.arc(cx+X*R,cy+sl*R,0.8+2*Z*(0.4+0.6*wv),0,6.2832);x.fill();
}
}
};
var last=0;
function loop(ts){
if(ts-last>33){last=ts;for(var i=0;i<mats.length;i++)if(mats[i].vis)mats[i].draw(ts);}
requestAnimationFrame(loop);
}
function countUp(el){
var txt=el.textContent.trim();if(/×/.test(txt)||el.children.length)return;
var m=txt.match(/^(\D*?)(\d{1,3}(?:\.\d{3})+|\d+(?:[.,]\d+)?)(.*)$/);if(!m)return;
var pre=m[1],num=m[2],suf=m[3],thou=/^\d{1,3}(\.\d{3})+$/.test(num),dec=0,comma=num.indexOf(',')>-1,val;
if(thou)val=parseInt(num.replace(/\./g,''),10);else{var dm=num.match(/[.,](\d+)$/);if(dm)dec=dm[1].length;val=parseFloat(num.replace(',','.'));}
if(!val)return;
var fmt=function(v){if(thou)return Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g,'.');var s=v.toFixed(dec);return comma?s.replace('.',','):s;};
var st=null;function step(ts){if(!st)st=ts;var p=Math.min(1,(ts-st)/ 1500),e=1-Math.pow(2,-10*p);el.textContent=pre+fmt(val*e)+suf;if(p<1)requestAnimationFrame(step);else el.textContent=txt;}
requestAnimationFrame(step);
}
function withModel(list,key,val,label,use){
var out=list.slice(),idx=-1;
if(!(val>0))return{list:out,idx:-1};
for(var i=0;i<out.length;i++)if(Math.abs(out[i][key]-val)<0.001){idx=i;break;}
if(idx>-1){out[idx]=Object.assign({},out[idx],{l:label||out[idx].l,me:true});return{list:out,idx:idx};}
var o={l:label,me:true};o[key]=val;if(use)o.w=use;
out.push(o);out.sort(function(a,b){return a[key]-b[key];});
for(i=0;i<out.length;i++)if(out[i].me)idx=i;
return{list:out,idx:idx};
}
var ENVS=[
{n:'Sala buia',lux:50,need:300,bg:'#050506'},
{n:'Negozio, showroom',lux:600,need:600,bg:'radial-gradient(120% 90% at 50% 0%, #2a2a2e, #0e0e10)'},
{n:'Vetrina in città',lux:5000,need:3000,bg:'linear-gradient(180deg, #74767c, #2e2f33)'},
{n:'Esterno in ombra',lux:15000,need:4500,bg:'linear-gradient(180deg, #b4bac2, #636871)'},
{n:'Sole diretto',lux:80000,need:6000,bg:'linear-gradient(180deg, #f6f3ec, #d3ccbf)'}
];
var NITS=[
{v:500,l:'SolidWall 2.6',w:'Interni, sale e uffici'},
{v:2500,l:'SolidWall 2.5 · 2.97 · 3.91',w:'Interni molto luminosi'},
{v:3500,l:'Vitreo',w:'Vetrine, dietro il vetro'},
{v:4500,l:'SolidWall 2.97 Outdoor',w:'Esterni e facciate'},
{v:6000,l:'SolidWall 3.91 IP67',w:'Esterni esposti alle intemperie'},
{v:7000,l:'SlimWall 5 · 7000',w:'Sole diretto'}
];
if(window.__lwNits&&window.__lwNits.length>2)NITS=window.__lwNits;
var OLDV=[500,2500,3500,4500,6000,7000];
function stopFor(list,v){var b=0;list.forEach(function(s,i){if(Math.abs(s.v-v)<Math.abs(list[b].v-v))b=i;});return b;}
function nitsLab(root){
var q=function(s){return root.querySelector(s);};
var envBox=q('[data-lw-envs]'),range=q('[data-lw-range]'),ticks=q('[data-lw-ticks]');
var screen=q('.lw-nits__screen'),wash=q('.lw-nits__wash'),bloom=q('.lw-nits__bloom'),sky=q('.lw-nits__sky'),sun=q('.lw-nits__sun');
var mat=new Matrix(screen,'led');mat.vis=true;
var wm=withModel(NITS,'v',parseFloat(root.getAttribute('data-model-nit')),root.getAttribute('data-model-name'),'Questo modello'),NL=wm.list;
var ei=clamp(parseInt(root.getAttribute('data-env')||'2',10),0,ENVS.length-1),si=wm.idx>-1?wm.idx:stopFor(NL,OLDV[clamp(parseInt(root.getAttribute('data-stop')||'2',10),0,5)]);
range.max=NL.length-1;
ENVS.forEach(function(e,i){var b=document.createElement('button');b.type='button';b.className='lw-chip';b.innerHTML=e.n+'<small>'+itNum(e.lux)+' lux</small>';b.onclick=function(){ei=i;upd();};envBox.appendChild(b);});
NL.forEach(function(s){var sp=document.createElement('span');sp.textContent=itNum(s.v);if(s.me)sp.style.color='rgb(245,166,35)';ticks.appendChild(sp);});
var scale=root.parentNode.querySelector('[data-lw-scale]'),rows=[],RW=window.__lwRows||NL,MX=RW.reduce(function(a,s){return Math.max(a,s.v);},1000);
if(scale)RW.forEach(function(s){
var r=document.createElement('div');r.className='lw-scale__row lw-reveal';r.setAttribute('data-v',s.v);
r.innerHTML='<div class="lw-scale__v">'+itNum(s.v)+' <small style="font-size:13px;font-weight:600;color:rgba(255,255,255,.5)">nit</small></div><div class="lw-scale__bar"><i data-w="'+(s.v / MX*100).toFixed(1)+'%"></i></div><div class="lw-scale__n"><b>'+(s.href?'<a href="'+s.href+'" style="color:inherit;text-decoration:none">'+s.l+' ›</a>':s.l)+'</b>'+(s.w||'')+'</div>';
r.onclick=function(ev){if(ev.target.closest('a'))return;si=stopFor(NL,s.v);upd();root.scrollIntoView({behavior:'smooth',block:'center'});};scale.appendChild(r);rows.push(r);observe(r);
});
if(scale&&window.__lwTbd&&window.__lwTbd.length){var tb=document.createElement('div');tb.className='lw-scale__tbd lw-reveal';tb.innerHTML='<p>Luminosità definita sul progetto</p><div>'+window.__lwTbd.map(function(m){return '<a href="'+m.href+'">'+m.l+'</a>';}).join('')+'</div>';scale.appendChild(tb);observe(tb);}
range.addEventListener('input',function(){si=parseInt(range.value,10);upd();});
function upd(){
var e=ENVS[ei],s=NL[si],ratio=s.v / e.need,R=e.lux*0.02 / Math.PI,cr=(s.v+R)/ R;
envBox.querySelectorAll('.lw-chip').forEach(function(b,i){b.classList.toggle('is-on',i===ei);});
rows.forEach(function(r){r.classList.toggle('is-on',+r.getAttribute('data-v')===s.v);});
range.value=si;range.style.setProperty('--p',(si /(NL.length-1)*100)+'%');
sky.style.background=e.bg;sun.style.opacity=e.lux>=50000?1:0;
var glare=e.lux<1000&&ratio>4;
wash.style.opacity=e.lux<1000?0:clamp(0.92-0.72*ratio,0,0.92).toFixed(2);
bloom.style.opacity=glare?clamp((ratio-4)*0.09,0.15,0.9).toFixed(2):0;
mat.gain=clamp(0.55+0.6*Math.min(1,s.v / 3000)+(glare?0.35:0),0.4,1.5);
screen.querySelector('canvas').style.filter=glare?'brightness(1.6) saturate(1.2) blur(0.6px)':'none';
q('[data-lw-nit]').textContent=itNum(s.v)+' nit';q('[data-lw-line]').textContent=s.l;
q('[data-lw-cr]').textContent=cr>99?'> 1:99':'1:'+itNum(cr,1);
q('[data-lw-meter]').style.width=clamp(Math.min(ratio,1.6)/ 1.6*100,3,100)+'%';
q('[data-lw-envtag]').textContent=e.n+' · '+itNum(e.lux)+' lux';
var v=q('[data-lw-verdict]'),best=NITS.filter(function(n){return n.v>=e.need;})[0]||NITS[NITS.length-1],t,c,sm;
if(glare){t='Troppa luce per questo ambiente.';c='is-ok';sm='Abbaglia il pubblico: il sensore di luminosità NovaStar la riduce in automatico.';}
else if(ratio<0.35){t='Illeggibile.';c='is-low';sm='Lo schermo scompare nella luce ambiente. Per '+e.n.toLowerCase()+' servono almeno '+itNum(e.need)+' nit: '+best.l+'.';}
else if(ratio<0.8){t='Appena leggibile.';c='is-low';sm='I colori si sbiadiscono. Consigliato: '+best.l+' ('+itNum(best.v)+' nit).';}
else if(ratio<1.15){t='Buona leggibilità.';c='is-ok';sm='Immagine nitida per '+e.n.toLowerCase()+'.';}
else{t='Leggibilità eccellente.';c='is-top';sm='Contrasto pieno, colori fedeli anche con la luce di '+e.n.toLowerCase()+'.';}
v.className='lw-verdict '+c;v.innerHTML=t+'<small>'+sm+'</small>';
}
upd();
}
var PITCH=[
{p:1.53,l:'SolidWall 1.53 COB'},{p:1.9,l:'SolidWall 1.9'},{p:2.5,l:'SolidWall · SlimWall 2.5'},
{p:2.6,l:'SolidWall · QuickWall 2.6'},{p:2.97,l:'SolidWall 2.97'},{p:3.9,l:'Vitreo 3.9 · SolidWall 3.91'},
{p:5,l:'SlimWall 5'},{p:6,l:'Vitreo 6'},{p:6.67,l:'SolidWall 6.67'}
];
function pitchLab(root){
var q=function(s){return root.querySelector(s);};
var cv=q('[data-lw-pitchcanvas]'),x=cv.getContext('2d'),range=q('[data-lw-prange]'),ticks=q('[data-lw-pticks]');
var wm=withModel(PITCH,'p',parseFloat(root.getAttribute('data-model-pitch')),root.getAttribute('data-model-name')),PL=wm.list;
var si=wm.idx>-1?wm.idx:clamp(parseInt(root.getAttribute('data-stop')||'3',10),0,PL.length-1),cur=PL[si].p,target=cur,src=null,W=0,H=0,MM=250;
range.max=PL.length-1;
PL.forEach(function(s){var sp=document.createElement('span');sp.textContent=String(s.p).replace('.',',');if(s.me)sp.style.color='rgb(245,166,35)';ticks.appendChild(sp);});
function build(){
var r=cv.getBoundingClientRect(),d=Math.min(window.devicePixelRatio||1,2);W=Math.floor(r.width);H=Math.floor(r.height);if(!W||!H)return;
cv.width=Math.floor(W*d);cv.height=Math.floor(H*d);x.setTransform(d,0,0,d,0,0);
var o=document.createElement('canvas');o.width=W;o.height=H;var ox=o.getContext('2d');
ox.fillStyle='#000';ox.fillRect(0,0,W,H);
var g=ox.createRadialGradient(W*0.74,H*0.42,4,W*0.74,H*0.42,H*0.4);g.addColorStop(0,'#fff');g.addColorStop(0.35,'rgb(245,166,35)');g.addColorStop(1,'rgba(245,166,35,0)');
ox.fillStyle=g;ox.fillRect(0,0,W,H);
var fs=Math.round(Math.min(H*0.27,W*0.16));
ox.fillStyle='#fff';ox.font='800 '+fs+'px Inter, Helvetica, Arial, sans-serif';ox.textBaseline='middle';ox.fillText('LUMLY',W*0.07,H*0.42);
ox.font='600 '+Math.round(fs*0.26)+'px Inter, Helvetica, Arial, sans-serif';ox.fillStyle='rgba(255,255,255,0.75)';ox.fillText('LED WALL',W*0.075,H*0.42+fs*0.75);
src=ox.getImageData(0,0,W,H).data;
}
function draw(){
if(!src)return;x.clearRect(0,0,W,H);var k=W / MM,s=cur*k;
for(var yy=s / 2;yy<H-40;yy+=s)for(var xx=s / 2;xx<W;xx+=s){
var i=((Math.floor(yy)*W)+Math.floor(xx))*4,r=src[i],gg=src[i+1],b=src[i+2],L=(r+gg+b)/ 765;
if(L<0.04){x.fillStyle='rgba(255,255,255,0.06)';x.fillRect(xx-0.5,yy-0.5,1,1);continue;}
x.fillStyle='rgb('+r+','+gg+','+b+')';x.beginPath();x.arc(xx,yy,Math.max(0.6,s*0.36*Math.sqrt(L)),0,6.2832);x.fill();
}
}
function tick(){if(Math.abs(cur-target)>0.01){cur+=(target-cur)*0.18;draw();requestAnimationFrame(tick);}else{cur=target;draw();}}
function upd(){
var p=PL[si].p;target=p;range.value=si;range.style.setProperty('--p',(si /(PL.length-1)*100)+'%');
q('[data-lw-pv]').textContent=String(p).replace('.',',')+' mm';q('[data-lw-pl]').textContent=PL[si].l;
q('[data-lw-dist]').textContent=itNum(p,1)+' m';q('[data-lw-best]').textContent=itNum(p*2,0)+'–'+itNum(p*3,0)+' m';
q('[data-lw-ppm]').textContent=itNum(Math.pow(1000 / p,2));
q('[data-lw-gap]').style.width=(40+p / 6.67*200)+'px';
var u=p<2?'Sale riunioni, showroom e hall di lusso: si guarda da vicino.':p<3?'Hall, palchi e convention: visione da qualche metro.':p<4.5?'Vetrine, eventi e grandi sale: dalla strada o dalla platea.':'Facciate e piazze: visione da lontano, massima luminosità.';
q('[data-lw-puse]').innerHTML='Ideale per'+'<small>'+u+'</small>';
if(RM){cur=p;draw();}else tick();
}
range.addEventListener('input',function(){si=parseInt(range.value,10);upd();});
build();upd();
var rt;window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(function(){build();draw();},200);});
if(document.fonts&&document.fonts.ready)document.fonts.ready.then(function(){build();draw();});
}
var io=null;
function observe(el){if(io)io.observe(el);else el.classList.add('is-in');}
function init(){
setHdr();
if('IntersectionObserver' in window){
io=new IntersectionObserver(function(entries){
entries.forEach(function(e){
if(!e.isIntersecting)return;var t=e.target;t.classList.add('is-in');io.unobserve(t);
if(!RM)t.querySelectorAll('.lw-fact__v, .lw-tile__v').forEach(countUp);
var bi=t.querySelector('.lw-scale__bar i');if(bi)bi.style.width=bi.getAttribute('data-w');
});
},{rootMargin:'0px 0px -8% 0px',threshold:0.08});
}
document.querySelectorAll('.lw-reveal').forEach(observe);
document.querySelectorAll('.lw-ph').forEach(function(el){new Matrix(el,el.classList.contains('lw-ph--wave')?'wave':el.classList.contains('lw-ph--glass')?'glass':'led');});
document.querySelectorAll('[data-lw-nits]').forEach(nitsLab);
document.querySelectorAll('[data-lw-pitch]').forEach(pitchLab);
if('IntersectionObserver' in window){
var mio=new IntersectionObserver(function(en){en.forEach(function(e){mats.forEach(function(m){if(m.el===e.target){m.vis=e.isIntersecting;if(RM&&m.vis)m.draw(0);}});});},{rootMargin:'100px'});
mats.forEach(function(m){mio.observe(m.el);});
}else mats.forEach(function(m){m.vis=true;});
if(!RM)requestAnimationFrame(loop);else mats.forEach(function(m){m.draw(0);});
var rt;window.addEventListener('resize',function(){setHdr();clearTimeout(rt);rt=setTimeout(function(){mats.forEach(function(m){m.resize();if(RM)m.draw(0);});},150);},{passive:true});
var hero=document.querySelector('.lw-hero__media');
if(hero&&!RM){
var onScroll=function(){var r=hero.getBoundingClientRect(),vh=window.innerHeight,p=clamp((vh-r.top)/(vh*0.9),0,1);hero.style.transform='scale('+(0.9+0.1*p).toFixed(4)+')';};
window.addEventListener('scroll',onScroll,{passive:true});onScroll();
}
document.querySelectorAll('[data-lw-track]').forEach(function(track){
var root=track.closest('.lw-hl');if(!root)return;
var step=function(){var c=track.querySelector('.lw-hl__card');return c?c.getBoundingClientRect().width+20:400;};
var p=root.querySelector('[data-lw-prev]'),n=root.querySelector('[data-lw-next]');
if(p)p.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'});});
if(n)n.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'});});
});
var nav=document.querySelector('.lw-localnav');
if(nav&&'IntersectionObserver' in window){
var links=nav.querySelectorAll('.lw-localnav__links a[href^="#"]'),map={};
links.forEach(function(a){var t=document.getElementById(a.getAttribute('href').slice(1));if(t)map[t.id]=a;});
var so=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting&&map[e.target.id]){links.forEach(function(l){l.classList.remove('is-active');});map[e.target.id].classList.add('is-active');}});},{rootMargin:'-45% 0px -50% 0px'});
Object.keys(map).forEach(function(id){so.observe(document.getElementById(id));});
}
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();